import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {addModelos, fetchCasos, adminModels} from '../../actions';
import {startLoading, endLoading} from '../../actions/loadingActions';
import _ from 'lodash';
import axios from "axios";
import ModelsStep1 from './models/ModelsStep1'
import ModelsStep2 from './models/ModelsStep2'
import Steps from './newcaso/Steps'

class ModelosForm extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.state = {
            page: 1,
            steps: [
                {title: "Modelos", status: "active"},
                {title: "IPR / Ataches", status: "disabled"}
            ],
            files: [],
            values: []
        };
    }
    componentDidMount() {
        this.props.fetchCasos();
    }
    nextPage(values) {
        console.log(values)
        var self = this;
        let newSteps = this.state.steps.map(function (item, i) {
            let n = i + 1;
            if(n <= self.state.page){
                item.status = "complete";
            } else if(n === self.state.page+1){
                item.status = "active";
            }else{
                item.status = "disabled";
            }
            return item;
        });
        this.setState({
            page: this.state.page + 1,
            steps: newSteps,
            values: values
        });
    }

    previousPage(files) {
        var self = this;
        let newSteps = this.state.steps.map(function (item, i) {
            let n = i + 1;
            if(n >= self.state.page){
                item.status = "disabled";
            } else if(n === self.state.page-1){
                item.status = "active";
            }else{
                item.status = "complete";
            }
            return item;
        });
        this.setState({
            page: this.state.page - 1,
            steps: newSteps,
            files
        });
    }
    onSubmit(values){
        this.props.adminModels(values);
    }
    render(){
        const { onSubmit } = this.props;

        const { handleSubmit } = this.props;
        return(
            <div className="justify-content-md-center">
                <div className="col-12 content-container form-container">
                    <Steps steps={this.state.steps} />
                    {{
                        1: (
                            <ModelsStep1
                                casoId={this.props.casoId}
                                startLoading={this.props.startLoading}
                                endLoading={this.props.endLoading}
                                nextPage={this.nextPage}
                                prevFiles={this.state.files}
                                caso={this.props.caso}
                            />
                        ),
                        2: (
                            <ModelsStep2
                                casoId={this.props.casoId}
                                caso={this.props.caso}
                                stepsGroup={this.props.caso.stepsGroup}
                                onSubmit={this.onSubmit.bind(this)}
                                files={this.state.values}
                                history={this.props.history}
                                startLoading={this.props.startLoading}
                                endLoading={this.props.endLoading}
                                previousPage={this.previousPage}
                            />
                        )

                    }[this.state.page]}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        loading: state.loading,
        caso: state.caso,
    };
}

export default connect(mapStateToProps, {
    addModelos,
    fetchCasos,
    startLoading,
    endLoading,
    adminModels
})(ModelosForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/ModelosForm.jsx